import React from 'react';

import Hero from '../components/Hero';
import IconContentBlock from '../components/IconContentBlock';
import Section from '../components/Section';

const features = [
  {
    icon: 'GRAPHCMS',
    title: 'Getting Started',
    description:
      'Get started with this hands on tutorial to get you up and running with GraphCMS.',
    cta: 'Take the tutorial',
    ctaTo: '/docs/guides/quickstart/',
  },
  {
    icon: 'SLACK',
    title: 'Community Slack',
    description:
      'Join our community and chat with other users building with GraphCMS.',
    cta: 'Request an invite',
    ctaTo: 'https://slack.graphcms.com',
  },
  {
    icon: 'TUNING',
    title: 'API Documentation',
    description:
      'Browse our documentation, tutorials, and learn more about the GraphCMS app.',
    ctaTo: '/docs',
  },
  {
    icon: 'GRAPHQL',
    title: 'Examples',
    description:
      'Browse our extensive range of examples with the most common frontend libraries and frameworks.',
    cta: 'View examples',
    ctaTo: '/docs/develop/code-examples',
  },
  {
    icon: 'QUESTION',
    title: 'FAQs',
    description:
      'Find answers to the most common questions asked by our community.',
    cta: 'FAQs',
    ctaTo: '/faq',
  },
  {
    icon: 'CHAT',
    title: 'Chat',
    description: 'Connect with us in chat about any account specific requests.',
    cta: 'Chat with us',
    ctaTo: '#',
    ctaClass: 'text-cornflower open_intercom',
  },
];

const SupportBaseTemplate = ({ pageContext: { page } }) => {
  if (!page) return null;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page} />
        <div className="md:flex md:flex-wrap -mx-6">
          {features.map(IconContentBlock)}
        </div>
      </Section>
    </React.Fragment>
  );
};

export default SupportBaseTemplate;
